import throwError from '../../utils/error/_throwError';
import resolveScope from '../../utils/redux/_resolveScope';

export type SubscriptionPath = {
  path: string;
  key: string;
};

/**
 * Returns a list of object, each representing a subscription to store changes, with the shape { key: string, path: string }
 */
function getSubscriptionPaths(keyMap: Record<string, string>, scope: string[], subscriptionPaths: SubscriptionPath[] = []) {
  addSubscriptionPaths(keyMap, scope, subscriptionPaths);

  return subscriptionPaths;
}

function addSubscriptionPaths(keyMap: Record<string, string>, scope: string[], subscriptionPaths: SubscriptionPath[]) {
  if (typeof keyMap === 'string') {
    const resolvedScope = resolveScope(keyMap, scope);
    subscriptionPaths.push({ path: resolvedScope, key: resolvedScope.split('.').pop() });
  } else if (Array.isArray(keyMap)) {
    addAllSubscriptionPaths(keyMap, scope, subscriptionPaths);
  } else if (keyMap !== null && typeof keyMap === 'object') {
    Object.keys(keyMap).forEach((key) => {
      const path = keyMap[key];
      const resolvedScope = resolveScope(path, scope);
      subscriptionPaths.push({ path: resolvedScope, key });
    });
  } else {
    throwError('getSubscriptionPaths: Only string, object, or array of string or object are accepted.');
  }
}

function addAllSubscriptionPaths(keyMaps: Record<string, string>[], scope: string[], subscriptionPaths: SubscriptionPath[]) {
  keyMaps.forEach((keyMap) => (
    addSubscriptionPaths(keyMap, scope, subscriptionPaths)
  ));
}

export default getSubscriptionPaths;
